import {PromotionCardCodeType, PromotionCardProductNameCodeType} from '@web/core/constants'

/** string 을 PromotionCardCodeType로 변환 (타입 단언) */
export function toPromotionCardCode(promotionCardCode: string): PromotionCardCodeType {
    return promotionCardCode as PromotionCardCodeType
}

/** string 배열을 PromotionCardCodeType 배열로 안전하게 변환 */
export function toPromotionCardCodeTypes(promotionCardCodes: Maybe<string[]>): PromotionCardCodeType[] {
    if (!promotionCardCodes) {
        return []
    }
    return promotionCardCodes.map(toPromotionCardCode)
}

/** string 을 PromotionCardProductNameCodeType로 변환 (타입 단언) */
export function toPromotionCardProductNameCode(promotionCardProductNameCode: string): PromotionCardProductNameCodeType {
    return promotionCardProductNameCode as PromotionCardProductNameCodeType
}

/** string 배열을 PromotionCardProductNameCodeType로 배열로 안전하게 변환 */
export function toPromotionCardProductNameCodeTypes(
    promotionCardProductNameCodes: Maybe<string[]>,
): PromotionCardProductNameCodeType[] {
    if (!promotionCardProductNameCodes) {
        return []
    }
    return promotionCardProductNameCodes.map(toPromotionCardProductNameCode)
}
